import React from "react";

const Footer = () => {
  return (
    <div className="container-fluid bg bg-dark py-3">
      <div className="row">
        <div className="col-12">
          <p className="text-white text-center m-0">
            © 2022 <strong>Craft Store</strong>Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
